import {inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {filter, map, Observable, withLatestFrom} from 'rxjs';
import {Store} from '@ngrx/store';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {PATH_FOR} from '@app/app.routes';
import {isPopulatedString} from '@aviary/store/common/typing.helpers';

@Injectable({
  providedIn: 'root'
})
export class PartialAuthGuard {
  private readonly store = inject(Store);
  private readonly router: Router = inject(Router);

  // This guard is derived from NotLoggedInGuard but allows an exception:
  // the user may be logged in with no 'google_guid' in order to access the existing account registration pages
  public canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(PatronSelectors.Auth.finishedLoading).pipe(
      filter((loaded) => loaded),
      withLatestFrom(this.store.select(PatronSelectors.Auth.googleUid)),
      map(([, googleUid]) => !isPopulatedString(googleUid) || this.router.createUrlTree([PATH_FOR['DASHBOARD']]))
    );
  }
}
